import { Injectable, Inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, switchMap, catchError, exhaustMap, tap } from 'rxjs/operators';
import { from, of } from 'rxjs';
import { AuthenticationService } from '../../core/services/auth.service';
import {
  login,
  loginSuccess,
  loginFailure,
  logout,
  logoutSuccess,
  Register,
  RegisterSuccess,
  RegisterFailure,
} from './authentication.actions';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { AuthfakeauthenticationService } from 'src/app/core/services/authfake.service';
import { UserProfileService } from 'src/app/core/services/user.service';
import { User as FirebaseUser } from 'firebase/auth';

@Injectable()
export class AuthenticationEffects {
  constructor(
    @Inject(Actions) private actions$: Actions,
    private AuthenticationService: AuthenticationService,
    private AuthfakeService: AuthfakeauthenticationService,
    private userService: UserProfileService,
    private router: Router
  ) {}

  Register$ = createEffect(() =>
    this.actions$.pipe(
      ofType(Register),
      exhaustMap(({ email, username, password }) => {
        if (environment.defaultauth === 'fakebackend') {
          return this.userService.register({ email, username, password }).pipe(
            map((user) => {
              this.router.navigate(['/auth/login']);
              return RegisterSuccess({ user });
            }),
            catchError((error) => of(RegisterFailure({ error })))
          );
        } else {
          return this.AuthenticationService.register({ email, password }).pipe(
            map((user: FirebaseUser) => {
              this.router.navigate(['/auth/login']);
              return RegisterSuccess({ user });
            }),
            catchError((error) => {
              console.error('Firebase register error:', error);
              return of(RegisterFailure({ error }));
            })
          );
        }
      })
    )
  );

  login$ = createEffect(() =>
    this.actions$.pipe(
      ofType(login),
      exhaustMap(({ email, password }) => {
        if (environment.defaultauth === 'fakebackend') {
          return this.AuthfakeService.login(email, password).pipe(
            map((user) => {
              if (user) {
                localStorage.setItem('currentUser', JSON.stringify(user));
                localStorage.setItem('token', user.token);
                this.router.navigate(['/']);
              }
              return loginSuccess({ user });
            }),
            catchError((error) => of(loginFailure({ error })))
          );
        } else if (environment.defaultauth === 'firebase') {
          return this.AuthenticationService.login(email, password).pipe(
            map((user: FirebaseUser) => {
              if (user?.uid) {
                sessionStorage.setItem('uid', user.uid);
              }
              this.router.navigate(['/']);
              return loginSuccess({ user });
            }),
            catchError((error) => {
              console.error('Firebase login error:', error);
              return of(loginFailure({ error }));
            })
          );
        } else {
          return of(loginFailure({ error: 'Unknown auth type' }));
        }
      })
    )
  );

  logout$ = createEffect(() =>
    this.actions$.pipe(
      ofType(logout),
      exhaustMap(() => {
        if (environment.defaultauth === 'firebase') {
          return from(this.AuthenticationService.logout()).pipe(
            map(() => {
              this.router.navigate(['/auth/login']);
              return logoutSuccess();
            })
          );
        } else {
          this.AuthfakeService.logout();
          this.router.navigate(['/auth/login']);
          return of(logoutSuccess());
        }
      })
    )
  );
}
